import { HeadItemType, Table } from 'components/Table'
import { AnalysisInconsistency } from 'services/analysis/interfaces'
import { useDispatch } from 'store/store'
import { Modal } from 'components'
import { setUploadErrors } from 'store/ExtraVolumeContext/ExtraVolumeSlice'

import * as S from './styles'

const headDataUpload: HeadItemType[] = [
  { label: 'Linha', columnName: 'Linha' },
  { label: 'Nome da Coluna', columnName: 'Coluna' },
  { label: 'Descrição de erro', columnName: 'Mensagem' }
]

interface UploadAnalysisErrorModalProps {
  data: AnalysisInconsistency[]
}

const UploadAnalysisErrorModal: React.FC<UploadAnalysisErrorModalProps> = ({ data }) => {
  const dispatch = useDispatch()

  const handleSetOpen = (isOpen: boolean) => {
    if (!isOpen) {
      dispatch(setUploadErrors([]))
    }
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.Linha}-${item.Coluna}`

      return {
        id: `id-${key}`,
        content: [
          <S.DataWrap key={`lineNumber-${key}`}>
            <span>{item.Linha}</span>
          </S.DataWrap>,
          <S.DataWrap key={`colName-${key}`}>
            <span>{item.Coluna}</span>
          </S.DataWrap>,
          <S.DataWrap key={`ErrorDescription-${key}`}>
            <span>{item.Mensagem}</span>
          </S.DataWrap>
        ]
      }
    })
  }

  return (
    <Modal
      title={'Resumo das inconsistências'}
      open={data.length > 0}
      setOpen={handleSetOpen}
      modalWidth={1000}
    >
      <S.Container>
        <S.Summary>{renderSummary()}</S.Summary>
        <Table
          headData={headDataUpload}
          bodyData={renderBody()}
          rowHeight={40}
          distributeWidth={false}
        />
      </S.Container>
    </Modal>
  )
}

export default UploadAnalysisErrorModal
